import React from 'react'
import { Link } from 'react-router-dom'
import styles from '../../../KYCDetails/KYCDetailsStyles/KYCDetailsStyle.module.scss'

const TransactionDetailComponent = ({
    type,
    status_name,
    payment_method_name,
    payment_reference,
    receipt_link,
    proof_of_payment_link }: any) => {
    return (
        <div className='row justify-content-between'>
            <div className='col-12 d-flex my-6'>
                {/* <div className='col-6 row my-6'> */}
                <span className='pe-0 text-muted fw-bold text-muted d-block fs-7'>{`${type} Status - `}</span>
                <div className='ms-2'>
                    <span className={`badge 
                              ${status_name.toLowerCase() === 'pending'
                            ? 'badge-light-warning'
                            : status_name.toLowerCase() === 'processing'
                                ? `${styles.status_processing}` :
                                status_name.toLowerCase() === 'completed'
                                    ? 'badge-light-success' :
                                    status_name.toLowerCase() === 'failed'
                                        ? 'badge-light-danger' :
                                        status_name.toLowerCase() === 'overdue'
                                            ? 'badge-light-danger' :
                                            'badge-light-dark'
                        } fs-8 fw-bold`}
                    >
                        {status_name ? status_name : 'NA'}
                    </span>
                </div>
                {/* </div> */}
            </div>
            <div className='col-6 row mb-6'>
                <label className='col-lg-6 fw-bold text-muted'>Transaction Type</label>
                <div className='col-lg-6'>
                    <span className='fw-bold fs-6 pb-1'>
                        {/* {PANGSTCINNumber.pan ? PANGSTCINNumber.pan : "-"} */}
                        {payment_method_name}
                    </span>
                </div>
            </div>
            <div className='col-6 row mb-6'>
                <label className='col-lg-5 fw-bold text-muted'>Transaction Reference</label>
                <div className='col-lg-7'>
                    <p className='fw-bold fs-6 pb-1' style={{wordWrap: "break-word"}}>
                        {payment_reference}
                    </p>
                </div>
            </div>
            <div className='col-12 d-flex'>
                {
                    receipt_link &&
                    <div className='me-4'>
                        <Link to={receipt_link} target="_blank" className='btn btn-primary'>{`${type} Receipt`}</Link>
                        {/* <p className='fw-bold text-muted fs-8 mb-0'>
                            {`${type} paid on`}
                        </p>
                        <p className='fw-bold text-muted fs-8 mb-0'>
                            Jan 24, 2024, 11:39 AM
                        </p> */}
                    </div>
                }
                {
                    proof_of_payment_link &&
                    <div className=''>
                        <Link to={proof_of_payment_link} target="_blank" className='btn btn-primary'>Proof of Payment</Link>
                        {/* <p className='fw-bold text-muted fs-8 mb-0'>
                            {`${type} paid on`}
                        </p>
                        <p className='fw-bold text-muted fs-8 mb-0'>
                            Jan 24, 2024, 11:39 AM
                        </p> */}
                    </div>
                }
            </div>
        </div>
    )
}

export default TransactionDetailComponent